import { FunctionComponent, ReactElement, ReactNode } from 'react';
import TextField, { TextFieldProps } from './TextField';

type MultiselectFieldProps = TextFieldProps & {
	renderValue: (selected: string[]) => ReactNode;
};

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const ITEMS_FIT_COEFFICIENT = 4.5;

const PaperProps = {
	style: {
		maxHeight: ITEM_HEIGHT * ITEMS_FIT_COEFFICIENT + ITEM_PADDING_TOP,
	},
};

const MultiselectField: FunctionComponent<MultiselectFieldProps> = ({
	value,
	onChange,
	renderValue,
	...props
}): ReactElement => (
	<TextField
		{...props}
		select
		onChange={onChange}
		SelectProps={{
			multiple: true,
			value,
			MenuProps: { PaperProps },
			renderValue: (selected) => renderValue(selected as string[]),
		}}
	/>
);

export default MultiselectField;
